// extracted by css-extract-rspack-plugin
export default {"skeleton":"skeleton-NjZh0t","pulse":"pulse-gmXswH","skeletonStatic":"skeletonStatic-iqwY_F"};